import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row w-full"
}
const _hoisted_2 = { class: "col w-full" }
const _hoisted_3 = { class: "colend" }
const _hoisted_4 = {
  key: 0,
  class: "col w-full h-full"
}
const _hoisted_5 = { class: "row w-full" }
const _hoisted_6 = {
  key: 1,
  class: "col w-full h-full"
}
const _hoisted_7 = { class: "row w-full" }
const _hoisted_8 = { class: "col w-full" }
const _hoisted_9 = { class: "row w-full" }
const _hoisted_10 = { class: "col w-full" }
const _hoisted_11 = { class: "colend" }
const _hoisted_12 = { class: "row w-full mtop-02" }
const _hoisted_13 = { class: "row w-full mtop-02" }
const _hoisted_14 = { class: "row w-full mtop-02" }

import { computed } from "vue";
import { EventInput } from "@fullcalendar/core/index.js";
import PersonService from "@/services/PersonService";
import { AppointmentPropsResponseStatusEnum, UserAppointmentStatusEnum } from '@/apiGenerate/medserver';
import { DateFormat, ItemTag } from "@/models/share.model";
import { useCurrentEntryStore } from "@/stores/currentEntry";
import { useRouter } from "vue-router";
import { useUiStore } from "@/stores/ui";
import { format } from 'date-fns'
import EsWaitingRoomBadge from "../esWaitingRoomBadge.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'esTemplateEvent',
  props: {
    appointment: {},
    smallDisplay: { type: Boolean },
    cssClass: {},
    selectedDoctor: {},
    doctors: {}
  },
  setup(__props: any) {

const props = __props;

const currentEntryStore = useCurrentEntryStore();
const uiStore = useUiStore();
const router = useRouter();

const eventTime = computed(() => {
    const appointmentStart = props.appointment.event.start;
    const startDate = new Date(appointmentStart);
    return startDate.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
});
const trimColor = computed(() => props.appointment.event.extendedProps.trimColor);

const getClass = () => {
    if (props.appointment.event.extendedProps.status === AppointmentPropsResponseStatusEnum.Honoured) {
        return "esEventBorderHonoured";
    } else if (props.appointment.event.extendedProps.status === AppointmentPropsResponseStatusEnum.WaitingRoom) {
        return "esEventBorderWaiting";
    } else if (props.appointment.event.extendedProps.status === AppointmentPropsResponseStatusEnum.NotHonoured) {
        return "esEventNotHonoured";
    }
}

const setLoadingScreenTexts = () => {
  const loadingText = PersonService.formatHonorificAndName(null, props.appointment.event.extendedProps.lastname, props.appointment.event.extendedProps.firstname);
  uiStore.setLoadingScreenText(loadingText);

  if (props.appointment.event.extendedProps.birthdate) {
    const loadingSubText = format(new Date(props.appointment.event.extendedProps.birthdate), DateFormat.FRONT_LONG);
    uiStore.setLoadingScreenSubText(loadingSubText);
  }  
}

const redirectPatientFolder = () => {
    if (props.appointment.event.extendedProps.patientId) {
        setLoadingScreenTexts();
        const patientId = props.appointment.event.extendedProps.patientId;

        if (patientId !== currentEntryStore.currentPatient?.personWithRoleId) {
            currentEntryStore.clearCurrentEntry();
        }

        router.push({
            name: "patient",
            params: { patientId: patientId }
        });
    }
}


return (_ctx: any,_cache: any) => {
  const _component_es_button_icon = _resolveComponent("es-button-icon")!

  return (_ctx.appointment.event.allDay)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", {
            class: _normalizeClass([_ctx.cssClass, "font-m font-bold-700"])
          }, _toDisplayString(_unref(PersonService).formatHonorificAndName(null, _ctx.appointment.event.extendedProps.lastname, _ctx.appointment.event.extendedProps.firstname)), 3)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (props.appointment.event.extendedProps.patientId)
            ? (_openBlock(), _createBlock(_component_es_button_icon, {
                key: 0,
                icon: "stethoscope",
                folder: "shareIcons",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectPatientFolder()))
              }))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["w-full font-size-10 cursor-action h-full esEventBorder", getClass()]),
        style: _normalizeStyle({ borderLeftColor: trimColor.value })
      }, [
        (_ctx.smallDisplay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", {
                  class: _normalizeClass(["font-bold-700", _ctx.cssClass])
                }, _toDisplayString(_ctx.appointment.event.title), 3)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", {
                        class: _normalizeClass([_ctx.cssClass, "font-m font-bold-700"])
                      }, _toDisplayString(_unref(PersonService).formatHonorificAndName(null, _ctx.appointment.event.extendedProps.lastname, _ctx.appointment.event.extendedProps.firstname)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      (props.appointment.event.extendedProps.patientId)
                        ? (_openBlock(), _createBlock(_component_es_button_icon, {
                            key: 0,
                            icon: "stethoscope",
                            folder: "shareIcons",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (redirectPatientFolder()), ["stop"]))
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.appointment.event.extendedProps.roomBadge && _ctx.appointment.event.extendedProps.status === _unref(UserAppointmentStatusEnum).WaitingRoom)
                        ? (_openBlock(), _createBlock(EsWaitingRoomBadge, {
                            key: 1,
                            class: "mtop-02",
                            color: _ctx.appointment.event.extendedProps.roomBadge.color,
                            text: _ctx.appointment.event.extendedProps.roomBadge.text
                          }, null, 8, ["color", "text"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.cssClass)
                }, _toDisplayString(_ctx.appointment.event.title), 3)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.cssClass)
                }, _toDisplayString(_ctx.appointment.event.extendedProps.comment), 3)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.cssClass)
                }, _toDisplayString(eventTime.value), 3)
              ])
            ]))
      ], 6))
}
}

})